const Home = () => {
  return <div className="sirkahome">
    <h1>Home - Stranka vo výstavbe</h1>
    </div>
  
}

export default Home